import styled from 'styled-components'
import Text from '../../atoms/Text'

const Container = styled.div`
  width: 100%;
  display: flex;
  algin-items: center;
  background-color:${(props) => props.theme.colors.neutral[100]};
  border-radius: 50px;
`
const TabItem = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 12px;
  border-radius: 50px;
  cursor: pointer;
  background-color: ${(props) => 
    props.$isActive ? props.theme.colors.primary : 'transparent'};
`
const TabGroup = ({ tabs, activeTab, onChange }) => {
  return (
    <Container>
      {tabs.map((tab) => {
        const isActive = activeTab === tab.id;
        return (
          <TabItem 
            key={tab.id} 
            $isActive={isActive} 
            onClick={() => onChange(tab.id)}
          >
            <Text
              variant="body2" 
              weight="medium"
              color={isActive ? "inverse" : "normal"}
            >
              {tab.label}
            </Text>
          </TabItem>
        );
      })}
    </Container>
  )
}

export default TabGroup
